(() => {
  const sectionSelector = '[data-hj-factory-video-section]';
  const videoSelector = '.hj-factory-video-card__video';
  const soundSelector = '[data-hj-factory-video-sound]';

  const updateSoundButton = (button, video) => {
    const soundOn = !video.muted;
    button.setAttribute('aria-pressed', String(soundOn));
    button.setAttribute('aria-label', soundOn ? 'Mute this video' : 'Play this video with sound');
  };

  const setupSection = (section) => {
    if (!section || section.dataset.hjFactoryVideoReady === 'true') return;
    section.dataset.hjFactoryVideoReady = 'true';

    const videos = Array.from(section.querySelectorAll(videoSelector));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;

      video.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });

      const button = video.parentElement?.querySelector(soundSelector);
      if (!button) return;
      updateSoundButton(button, video);
      button.addEventListener('click', () => {
        video.muted = !video.muted;
        if (video.paused) video.play().catch(() => {});
        updateSoundButton(button, video);
      });
    });

    if (reduceMotion || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.35 });

    videos.forEach((video) => observer.observe(video));
  };

  const setupAll = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach(setupSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
